module.exports = __webpack_public_path__ + "static/media/radio.3c3fd8c1.svg";